'use strict';

const $ = jQuery.noConflict();
$(function() {

	const faqBlock = {

		init: function() {
			this.cacheDOM();

			if (!this.$root.length || !this.$items.length) {
				return;
			}

			this.normalizeState();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$root = $('.js-faq-block');
			this.$items = this.$root.find('.js-faq-item');
		},

		bindEvents: function() {
			this.$root.on('click', '.js-faq-trigger', this.handleTriggerClick.bind(this));
		},

		handleTriggerClick: function(event) {
			event.preventDefault();

			const $trigger = $(event.currentTarget);
			const $item = $trigger.closest('.js-faq-item');

			if (!$item.length || $item.hasClass('is-open')) {
				return;
			}

			this.openItem($item, true);
		},

		normalizeState: function() {
			let $openItems = this.$items.filter('.is-open');

			if (!$openItems.length) {
				$openItems = this.$items.first().addClass('is-open');
			}

			const $activeItem = $openItems.first();

			this.$items.not($activeItem).each((index, element) => {
				this.closeItem($(element), false);
			});

			this.openItem($activeItem, false);
		},

		openItem: function($item, animate) {
			this.$items.not($item).each((index, element) => {
				this.closeItem($(element), animate);
			});

			$item.addClass('is-open');

			const $trigger = $item.find('.js-faq-trigger').first();
			const $panel = $item.find('.js-faq-panel').first();

			$trigger.attr('aria-expanded', 'true');
			$panel.prop('hidden', false);

			if (animate) {
				$panel.stop(true, true).slideDown(250);
			} else {
				$panel.stop(true, true).show();
			}
		},

		closeItem: function($item, animate) {
			$item.removeClass('is-open');

			const $trigger = $item.find('.js-faq-trigger').first();
			const $panel = $item.find('.js-faq-panel').first();

			$trigger.attr('aria-expanded', 'false');

			if (animate) {
				$panel.stop(true, true).slideUp(250, function() {
					$panel.prop('hidden', true);
				});
			} else {
				$panel.stop(true, true).hide();
				$panel.prop('hidden', true);
			}
		},

	};

	faqBlock.init();
});
